<!-- 新闻列表 -->
<template>
  <div class="component-news-list">
    <div class="all-content">
      <div class="title">
        <div class="bigtitle">
          <span class="titlestyle">全民公祭·</span>致敬英雄
        </div>
        <div
          class="jisaocontent"
          :class="{
            jisaocontentmobile: isphone,
            jisaocontentpc: isphone == false
          }"
        >
          <div class="jisaonum">
            您是第<span> {{ jisaonums }} </span>位祭扫者
            <button @click="zxjs()" class="jisaobtn">在线祭扫</button>
          </div>
        </div>
      </div>
      <div class="bigimg">
        <div class="jisao noselect" @click="zxjs()">在线祭扫</div>
      </div>
      <div class="listtitle">—— 线下公祭活动地址 ——</div>
      <div class="list">
        <!-- 致敬英雄栏目的数据 -->
        <div id="table">
          <vue-seamless-scroll :data="zjyl" class="seamless-warp">
            <ul>
              <li v-for="(item, index) in zjyl" :key="index" v-if="index < 15">
                <span class="titlehang1">
                  <a
                    :href="
                      item.basicSource
                        ? item.basicSource
                        : 'http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=' +
                          item.basicId
                    "
                    target="_blank"
                  >
                    {{ item.basicTitle }}
                  </a></span
                >
              </li>

              <!-- 下面这个是占位的 -->
              <!-- <li style="background-color:#fff;"></li> -->
            </ul>
          </vue-seamless-scroll>
          <!-- <table cellpadding="0" cellspacing="0">
            <tbody>
              <tr v-for="(item, index) in newsList" :key="index">
                <td width="33.33%">{{ item.title }}</td>
                <td width="33.33%">{{ item.title }}</td>
                <td width="33.33%">{{ item.title }}</td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>
      <!-- <div class="page">
        <ul>
          <li>＜ 上一页</li>
          <li>下一页 ＞</li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "ComponentNewsList",
  components: {
    vueSeamlessScroll
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  data() {
    return {
      isphone: false,
      addDetail: {},
      editlist: false,
      editDetail: {},
      editid: "",
      jisaonums: 516275
    };
  },
  mounted() {
    // 定一个当前时间戳
    var nowtime = 1632824350930;
    var time = Date.now();
    // 计算距离2021-09-28 18:19:10有多少分钟
    var resultval = Math.ceil((time - nowtime) / 10000);
    // 模拟每分钟10个祭扫的人
    this.jisaonums = this.jisaonums + resultval;

    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  props: ["zjyl"],
  methods: {
    zxjs() {
      window.open("http://www.chinamartyrs.gov.cn/v2/jisao/#/searchheros");
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.seamless-warp {
  width: 100%;
  height: 300px;
  overflow: hidden;
}
.jisaocontent {
  position: absolute;
  right: 0;
  bottom: 10px;
  display: -webkit-box;
}
.jisaocontent button {
  padding: 14px 28px;
  cursor: pointer;
  background-color: var(--main-color);
  border: 0;
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  margin-right: -1px;
}
.jisaocontent button:hover {
  color: #fff;
  background-color: rgb(240, 45, 45);
}
/* 祭扫人数 */
.jisaocontentpc .jisaonum {
  border: 1px solid var(--main-color);
  padding: 0 0 0 30px;
  font-size: 14px;
  box-sizing: border-box;
}

.jisaocontentmobile .jisaonum {
  border: 1px solid var(--main-color);
  padding: 0 0 0 30px;
  font-size: 14px;
  box-sizing: border-box;
}
.jisaonum span {
  color: var(--main-color);
}
.component-news-list {
  width: 1200px;
  min-width: 1200px;
  height: 1170px;
  background-color: rgb(255, 255, 255);
  border-radius: 15px;
  margin-top: 12px;
}
.all-content {
  width: 1140px;
  height: 1170px;
  position: relative;
  margin: 0 auto;
  top: 10px;
}
.title,
.bigimg,
.listtitle,
.list,
.page {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.title {
  line-height: 15px;
}
.bigimg {
  height: 644px;
  top: 50px;
  background: url(../assets/images/jisao.png) no-repeat;
  background-size: 100%;
}

.bigimg .jisao {
  width: 179px;
  height: 33px;
  font-size: 16px;
  text-align: center;
  line-height: 33px;
  margin: 0 auto;
  position: relative;
  top: 68%;
  right: 24px;
  background-color: #d0151b;
  color: #fff;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.9);
  transition: all 0.4s;
}
.bigimg .jisao:active {
  transition: width 3s;
  -moz-transition: width 3s; /* Firefox 4 */
  -webkit-transition: width 3s; /* Safari and Chrome */
  -o-transition: width 3s; /* Opera */
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.9);
}
.bigimg .jisao:hover {
  cursor: pointer;
}

.listtitle {
  height: 60px;
  line-height: 60px;
  position: relative;
  top: 65px;
  font-family: "思源宋体";
  font-size: 32px;
  text-align: center;
  color: #fff;
  background-color: var(--main-color);
}
.list {
  height: 305px;
  top: 75px;
}
.page {
  width: 257px;
  height: 30px;
  font-size: 13px;
  line-height: 30px;
  top: 140px;
  margin: 0 auto;
}

.page ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.page ul li {
  padding: 5px 35px;
}
.page ul li:hover {
  cursor: pointer;
  background-color: var(--main-color);
  color: #fff;
}
.page ul li:first-child {
  background-color: var(--main-color);
  color: #fff;
}
.page ul li:last-child {
  background-color: #ddd;
  color: #000;
}

/* 表格 */
#table table {
  width: 100%;
  font-size: 14px;
}
#table ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
#table ul li {
  width: 33%;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
#table ul li span {
  width: 90%;
  height: 60px;
  line-height: 60px;
  margin: 0 auto;
  font-size: 18px;
  text-align: center;
}
#table ul li:nth-child(3n + 1),
li:nth-child(3n + 2),
li:nth-child(3n + 3) {
  background-color: rgb(240 160 140 / 44%);
}
#table ul li:nth-child(6n + 4),
li:nth-child(6n + 5),
li:nth-child(6n + 6) {
  background-color: rgb(245 203 192 / 48%);
}
#table ul li span a {
  color: #000;
}
#table ul li span a:hover {
  color: var(--main-color);
}
/* 
table thead th {
  background: var(--main-color);
  color: #fff;
  font-size: 24px;
  padding: 20px 0;
  text-align: center;
  border-bottom: 6px solid rgb(255, 255, 255);
}
table thead th:nth-child(1),
th:nth-child(2) {
  border-right: 3px solid rgb(255, 255, 255);
}
table thead tr {
  height: 65px;
}

table tbody tr {
  height: 60px;
}
table tbody td {
  padding: 10px;
  font-size: 18px;
  text-align: center;
}
table tbody td:nth-child(1),
td:nth-child(2) {
  padding: 10px;
  font-size: 18px;
  text-align: center;
  border-right: 3px solid rgb(255, 255, 255);
}
table tbody tr:nth-child(odd) {
  background-color: rgb(240 160 140 / 44%);
}
table tbody tr:nth-child(even) {
  background-color: rgb(245 203 192 / 48%);
}
table tbody td span {
  margin: 0 10px;
  cursor: pointer;
} */
</style>



// WEBPACK FOOTER //
// src/components/zhijing.vue